module.exports = __webpack_public_path__ + "static/media/binarApps.aad1a34f.png";